import React from 'react';

import plakat from '../img/plakat.jpg'

const TennisSchool = (props) => {
    return (
        <div className="container">
            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr></hr>
                        <h2 className="intro-text text-center">Škola tenisa</h2>
                        <hr></hr>
                        <hr className="visible-xs"></hr>
                        <p>Teniski klub VAMOS organizira BESPLATNU školu tenisa za predškolsku i školsku djecu od 3.4.-14.4.2017. godine. </p>
                        <p>Prijaviti se možete <a href="https://goo.gl/SjYVTz" target="_blank">ovdje</a>.</p>
                        <img src={plakat} className="img-responsive img-center" alt=""/>
                    </div>
                </div>
             </div>
        </div>
    );
}

export default TennisSchool



// WEBPACK FOOTER //
// ./src/components/TennisSchool.js